import { render, staticRenderFns } from "./FetchPackage.vue?vue&type=template&id=662cabb3&"
import script from "./FetchPackage.vue?vue&type=script&lang=js&"
export * from "./FetchPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports